export const boardMembers = [
    {
        id: 'jeannie-prazak',
        name: 'Jeannie Prazak',
        role: 'Board Member',
        place: 'Place 1',
        photo: '/assets/images/board/jeannie-prazak.jpeg',
        bio: 'Jeannie Prazak is a dedicated member of the Venus community with a deep commitment to the economic development of our city. She brings valuable experience and insight to the VSCDC Board.',
        achievements: [],
        email: '',
        phone: '',
    },
    {
        id: 'katie-drambareanu',
        name: 'Katie Drambareanu',
        role: 'Vice Chair',
        place: 'Place 2',
        photo: '/assets/images/board/katie-drambareanu.jpeg',
        bio: 'Katie Drambareanu serves as Vice Chair of the Venus Community Service Development Corporation. Her leadership and vision continue to shape the economic landscape of Venus, Texas.',
        achievements: [],
        email: '',
        phone: '',
    },
    {
        id: 'michelle-crane',
        name: 'Michelle Crane',
        role: 'Board Member',
        place: 'Place 3',
        photo: '/assets/images/board/michelle-crane.jpeg',
        bio: 'Michelle Crane is a committed board member of the VSCDC, contributing her expertise to foster business growth and community development in Venus.',
        achievements: [],
        email: '',
        phone: '',
    },
    {
        id: 'elisabeth-livingstone',
        name: 'Dr. Elisabeth Livingstone',
        role: 'Board Member',
        place: 'Place 4',
        photo: '/assets/images/board/elisabeth-livingstone.jpeg',
        bio: 'Dr. Elisabeth Livingstone brings academic and professional expertise to the VSCDC Board. Her work supports the vision of a thriving, well-connected business community in Venus.',
        achievements: [],
        email: '',
        phone: '',
    },
    {
        id: 'joe-russell',
        name: 'Joe Russell',
        role: 'Chairperson',
        place: 'Place 6',
        photo: '/assets/images/board/joe-russell.jpeg',
        bio: 'Joe Russell serves as Chairperson of the Venus Community Service Development Corporation. His leadership guides the board in making strategic decisions that drive economic growth for the city of Venus.',
        achievements: [],
        email: '',
        phone: '',
    },
    {
        id: 'dejour-burton',
        name: "De'jour Burton",
        role: 'Board Member',
        place: 'Place 7',
        photo: '/assets/images/board/dejour-burton.jpg',
        bio: "De'jour Burton is a valued board member whose perspective and commitment to Venus helps drive forward the mission of the VSCDC.",
        achievements: [],
        email: '',
        phone: '',
    },
];

export const director = {
    id: 'oscar-ortiz',
    name: 'Oscar Ortiz',
    role: 'EDC Director',
    place: null,
    photo: '/assets/images/board/oscar-ortiz.jpeg',
    bio: 'Oscar Ortiz serves as the Economic Development Corporation Director for the City of Venus, Texas. He works alongside the VSCDC Board to attract businesses, support local growth, and strengthen the community\'s economic foundation.',
    achievements: [],
    email: 'oortiz@venustxedc.com',
    phone: '(972) 366-3348 ext. 206',
};
